export const SERVER_URL = 'https://ncltaimprintintl.com';



// WEBPACK FOOTER //
// ./src/modules/services/constants.service.js